// @ actions
const signaturePatternActions = require('actions/signaturePattern');

// @ constants
const actionTypes = require('constants/contactCenter/actionTypes');
const API_CHANNEL = 'CIC';
const REQUEST_NEW_CARD_VALIDATE = 'preconfirmacion';
const REQUEST_NEW_CARD_CONFIRMATION = 'postconfirmacion';
const {
    API_ENTERPRISE_NUMBER,
    API_CENTER,
    FIRST_STEP,
    SECOND_STEP,
    WIZARD_FIRST_STEP,
    WIZARD_SECOND_STEP
} = require('constants/index');

//@utilities
const { APIPost } = require('utilities/APIRequestHelper');
const { fromArray } = require('utilities/dateHelper');
const { formatAmountForService } = require('utilities/currencyHelper');

const cardRequestAdditionalFetchDataStart = () => ({
    type: actionTypes.CARD_REQUEST_ADDITIONAL_FETCH_DATA_START,
});

const cardRequestAdditionalFetchDataSuccess = (cardId, response) => ({
    type: actionTypes.CARD_REQUEST_ADDITIONAL_FETCH_DATA_SUCCESS,
    payload: {
        cardId,
        response: Object.assign({}, response)
    }
});

const cardRequestAdditionalFetchDataError = error => ({
    type: actionTypes.CARD_REQUEST_ADDITIONAL_FETCH_DATA_ERROR,
    payload: {
        error
    }
});

const setVisibleStep = step => ({
    type: actionTypes.CARD_REQUEST_ADDITIONAL_SET_VISIBLE_STEP,
    payload: {
        step
    }
});

const clearValidationRequest = () => ({
    type: actionTypes.CARD_REQUEST_ADDITIONAL_CLEAR_VALIDATION
});

const queryRequestAdditionalCardData = cardId => (dispatch, getState) => {
    const immCard = getState().cards.getIn(['byId', cardId]);

    const params = {
        query: {
            "canalMarco": API_CHANNEL,
            "contrato": {
                "centro": {
                    "centro": API_CENTER,
                    "empresa": API_ENTERPRISE_NUMBER
                },
                "numerodecontrato": immCard.getIn(['contract', 'number']),
                "producto": immCard.getIn(['contract', 'product'])
            },
            "pan": immCard.get('number'),
            "persona": {
                "codigodepersona": immCard.getIn(['person', 'personCode']),
                "tipodepersona": immCard.getIn(['person', 'personType'])
            }
        }
    };

    dispatch(cardRequestAdditionalFetchDataStart());

    return APIPost({ dispatch, endpoint: 'cardRequestAdditionalFetchData', params })
        .then(response => {
            dispatch(cardRequestAdditionalFetchDataSuccess(cardId, response));
        })
        .catch(response => {
            if(!!response.error) {
                dispatch(cardRequestAdditionalFetchDataError(response.error));
            } else {
                throw response;
            }
        });
};

const cardRequestAdditionalValidateStart = () => ({
    type: actionTypes.CARD_REQUEST_ADDITIONAL_VALIDATE_START,
});

const cardRequestAdditionalValidateSuccess = response => ({
    type: actionTypes.CARD_REQUEST_ADDITIONAL_VALIDATE_SUCCESS,
    payload: {
        response: Object.assign({}, response)
    }
});

const cardRequestAdditionalValidateError = error => ({
    type: actionTypes.CARD_REQUEST_ADDITIONAL_VALIDATE_ERROR,
    payload: {
        error
    }
});

const validateRequestAdditionalCard = () => (dispatch, getState) => {
    const cardId = getState().cardRequestAdditional.getIn([ 'steps', FIRST_STEP, 'cardId' ]);
    const immCard = getState().cards.getIn(['byId', cardId]);
    const immIntervener = getState().cardRequestAdditional.getIn([ 'steps', FIRST_STEP, 'intervenerId' ]);

    const params = {
        query: {
            "canalMarco": API_CHANNEL,
            "contrato": {
                "centro": {
                    "centro": API_CENTER,
                    "empresa": API_ENTERPRISE_NUMBER
                },
                "numerodecontrato": immCard.getIn(['contract', 'number']),
                "producto": immCard.getIn(['contract', 'product'])
            },
            "interviniente": {
                "codigodepersona": immIntervener.get('personCode'),
                "tipodepersona": immIntervener.get('personType')
            },
            "pan": immCard.get('number'),
            "persona": {
                "codigodepersona": immCard.getIn(['person', 'personCode']),
                "tipodepersona": immCard.getIn(['person', 'personType'])
            },
            "solicitudTarjetaNueva": REQUEST_NEW_CARD_VALIDATE
        }
    };

    dispatch(cardRequestAdditionalValidateStart());

    return APIPost({ dispatch, endpoint: 'cardRequestAdditionalValidate', params })
        .then(response => {
            dispatch(cardRequestAdditionalValidateSuccess(response));
            dispatch(setVisibleStep(WIZARD_SECOND_STEP));
        })
        .catch(response => {
            if(!!response.error) {
                dispatch(cardRequestAdditionalValidateError(response.error));
                dispatch(setVisibleStep(WIZARD_FIRST_STEP));
            } else {
                throw response;
            }
        });
}

const selectIntervener = intervenerId => ({
    type: actionTypes.CARD_REQUEST_ADDITIONAL_SELECT_INTERVENER,
    payload: {
        intervenerId
    }
});

const validateStepAction = step => ({
    type: actionTypes.CARD_REQUEST_ADDITIONAL_VALIDATE_STEP,
    payload: {
        step
    }
});

const validateStep = step => dispatch => {
    if (step === WIZARD_FIRST_STEP) {
        dispatch(validateRequestAdditionalCard());
    } else {
        dispatch(validateStepAction(step));
    }
};

const requestAdditionalCardConfirmationStart = () => ({
    type: actionTypes.CARD_REQUEST_ADDITIONAL_CONFIRMATION_START,
});

const requestAdditionalCardConfirmationSuccess = response => ({
    type: actionTypes.CARD_REQUEST_ADDITIONAL_CONFIRMATION_SUCCESS,
    payload: {
        response: Object.assign({}, response)
    }
});

const requestAdditionalCardConfirmationError = error => ({
    type: actionTypes.CARD_REQUEST_ADDITIONAL_CONFIRMATION_ERROR,
    payload: {
        error
    }
});

const getLimitsList = immLimits => {
    const limitsArray = immLimits.map(immLimit => ({
        "importeLimitePoliza": {
            "importe": formatAmountForService(immLimit.getIn([ 'importeLimitePoliza', 'importe' ], null)),
            "divisa": immLimit.getIn([ 'importeLimitePoliza', 'divisa' ], null)
        },
        "codigoModificacion": immLimit.get('codigoModificacion', null),
        "nombreColectivo": immLimit.get('nombreColectivo', null)
    })).toArray();

    return limitsArray.length === 0 ? null : { "limites": limitsArray };
}

const requestAdditionalCard = cardId => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const immCard = getState().cards.get('byId').get(cardId);
        const immValidateServiceResponse = getState().cardRequestAdditional.getIn([ 'steps', SECOND_STEP, 'validateServiceResponse' ]);
        const immIntervener = getState().cardRequestAdditional.getIn([ 'steps', FIRST_STEP, 'intervenerId' ]);

        const params = {
            query:  {
                "apellido1": immValidateServiceResponse.get('apellido1', null),
                "apellido2": immValidateServiceResponse.get('apellido2', null),
                "canal": API_CHANNEL,
                "codEstandarRefCOESTREF": immValidateServiceResponse.getIn([ 'datosAlta',  'codEstandarRefCOESTREF' ], null),
                "codigoIdiomaCODIDIO": immValidateServiceResponse.getIn([ 'datosAlta',  'idioma' ], null),
                "codigoSubProdIDSUBTIPO": immValidateServiceResponse.getIn([ 'datosAlta',  'codigoSubProdIDSUBTIPO' ], null),
                "codpersx": immValidateServiceResponse.getIn([ 'datosAlta',  'codpersx' ], null),
                "contrato": {
                    "centro": {
                        "centro": API_CENTER,
                        "empresa": API_ENTERPRISE_NUMBER
                    },
                    "numerodecontrato": immCard.getIn(['contract', 'number']),
                    "producto": immCard.getIn(['contract', 'product'])
                },
                dataToken,
                "domProveedor": immValidateServiceResponse.getIn([ 'datosAlta',  'nrodomicAux' ], null),
                "fechaCaducidadFECADVIG": fromArray(immValidateServiceResponse.getIn([ 'datosAlta',  'fechaCaducidadFECADVIG' ], null)),
                "fechaInicioFEINIVIG": fromArray(immValidateServiceResponse.getIn([ 'datosAlta',  'fechaInicioFEINIVIG' ], null)),
                "indicadorEnvioINDENV1": immValidateServiceResponse.getIn([ 'datosAlta',  'indicadorEnvioINDENV1' ], null),
                "indicadorEnvioRecepcionINDENV": immValidateServiceResponse.getIn([ 'datosAlta',  'indicadorEnvioRecepcionINDENV' ], null),
                "listaLimites": getLimitsList(immValidateServiceResponse.getIn([ 'datosAlta', 'listaLimites', 'limites' ], [])),
                "motivoSitu": immValidateServiceResponse.getIn([ 'datosAlta',  'motivoSituacion' ], null),
                "nombreAdicionalONOMADIC": immValidateServiceResponse.getIn([ 'datosAlta',  'nombreAdicionalONOMADIC' ], null),
                "nombreEstampado": immValidateServiceResponse.get('nombreEstampado', null),
                "numPersona": {
                    "codigodepersona": immIntervener.get('personCode'),
                    "tipodepersona": immIntervener.get('personType')
                },
                "pan": immCard.get('number'),
                "panMediosPagoPANMDP": immValidateServiceResponse.getIn([ 'datosAlta',  'panMediosPagoPANMDP' ], null),
                "persona": {
                    "codigodepersona": immCard.getIn(['person', 'personCode']),
                    "tipodepersona": immCard.getIn(['person', 'personType'])
                },
                "plasticoCODPLAS": immValidateServiceResponse.getIn([ 'datosAlta',  'plasticoCODPLAS' ], null),
                "solicitudTarjetaNueva": REQUEST_NEW_CARD_CONFIRMATION,
                "tipoPersonaListaTIPOPERX": immValidateServiceResponse.getIn([ 'datosAlta',  'tipoPersonaListaTIPOPERX' ], null),
                "tipoSituacionTIPSITUA": immValidateServiceResponse.getIn([ 'datosAlta',  'tipoSituacionTIPSITUA' ], null),
                "txtRelieve": immValidateServiceResponse.getIn([ 'datosAlta',  'txtRelieve' ], null),
                "ultimoNumAsigULNUMIAS": immValidateServiceResponse.getIn([ 'datosAlta',  'ultimoNumAsigULNUMIAS' ], null),
                "valorRequisitoEmpresa": immValidateServiceResponse.getIn([ 'datosAlta',  'valorRequisitoEmpresa' ], null),
                "valorRequisitoOp": immValidateServiceResponse.getIn([ 'datosAlta',  'valorRequisitoOp' ], null)
            }
        };

        dispatch(requestAdditionalCardConfirmationStart());

        return APIPost({ dispatch, endpoint: 'cardRequestAdditionalConfirmation', params })
            .then(response => {
                dispatch(requestAdditionalCardConfirmationSuccess(response));
            })
            .catch(response => {
                if(!!response.error) {
                    dispatch(requestAdditionalCardConfirmationError(response.error));
                } else {
                    throw response;
                }
            });
    };

    return new Promise(() => {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
};

const clearRequest = () => ({
    type: actionTypes.CARD_REQUEST_ADDITIONAL_CLEAR
});

module.exports = {
    queryRequestAdditionalCardData,
    selectIntervener,
    validateStep,
    setVisibleStep,
    requestAdditionalCard,
    clearRequest,
    clearValidationRequest
};
